/* Angular Component */
import {
  Component,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";

const ENTER = 13;
const RTL_CHAR_REGEX = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;

@Component({
  selector: "ichannel-input",
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.scss"],
})
export class InputComponent implements AfterViewInit {
  @ViewChild("inputElement") inputElement: ElementRef;
  @ViewChild("measureText") measureText: ElementRef;

  @Output()
  onFocusCallback = new EventEmitter();

  @Output()
  onKeyupCallback = new EventEmitter();

  @Output()
  onBlurCallback = new EventEmitter();

  @Output()
  output = new EventEmitter();
  @Output()
  valueChange = new EventEmitter();

  @Output()
  onEnterClicked = new EventEmitter();

  @Input()
  value;

  @Input()
  label;

  @Input()
  placeholder;

  @Input()
  maxLength = 5000;

  @Input()
  inputType = "text";

  @Input()
  feedWithEnter = false;

  @Input()
  direction = "row";

  @Input()
  autoGrow = false;

  itemId: string | number;
  inputDirection: 'ltr' | 'rtl' | 'auto' = 'ltr';

  ngOnInit() {
    this.generateId();
  }

  ngAfterViewInit() {
    if (this.autoGrow) {
      this.updateInputWidth();
    }
    this.detectDirection();
  }

  /**
   * Generating a unique id based on place holder and time zone (provided for label)
   * @return void
   */
  generateId() {
    if (!this.placeholder) return new Date().getTime();

    this.itemId = this.placeholder.replace(/\s/g, "-") + new Date().getTime();
  }

  /**
   * On Keyup listener
   * @param event
   */
  onKeyUp(event: KeyboardEvent) {
    if (event.which == ENTER && this.feedWithEnter) {
      this.update();
      this.value = "";
      return;
    }

    if (!this.feedWithEnter) this.update();

    this.onKeyupCallback.emit({
      event: event,
      data: this.value,
    });

    if (this.autoGrow) {
      this.updateInputWidth();
    }
    this.detectDirection();
  }

  onInput(event: Event): void {
    const inputEvent = event as InputEvent;
    if (inputEvent.inputType && inputEvent.inputType !== 'insertText') {
      this.update();
    }
    if (this.autoGrow) {
      this.updateInputWidth();
    }
    this.detectDirection();
  }

  /**
   * Updating Out the value
   * @return void
   */
  update(event?: any) {
    this.output.emit(this.value);
    this.valueChange.emit(this.value);
  }

  /**
   * Dispatch event when we have "onFocus" event
   * @return void
   */
  onFocus(event: any) {
    this.onFocusCallback.emit({
      event: event,
      data: this.value,
    });
  }

  /**
   *
   * @param event
   */
  onBlur(event: any) {
    this.onBlurCallback.emit({
      event: event,
      data: this.value,
    });
  }

  /**
   * Return boolean as
   * @returns {boolean}
   */
  isColumn() {
    return this.direction == "column";
  }

  isRow() {
    return this.direction == "row";
  }

  onEnterClickedEventHandler() {
    this.onEnterClicked.emit();
  }

  private updateInputWidth() {
    if (this.measureText && this.inputElement) {
      const width = this.measureText.nativeElement.offsetWidth;
      this.inputElement.nativeElement.style.width = `${Math.max(width + 20, 100)}px`;
    }
  }

  private detectDirection() {
    if (this.value && RTL_CHAR_REGEX.test(this.value)) {
      this.inputDirection = "rtl";
    } else {
      this.inputDirection = "ltr";
    }
  }
}
